import CTASubtext, { ctaSubtext } from './CTASubtext'
import styles from './CTA.module.scss'

interface CTASubtextGroupProps {
  subtexts: ctaSubtext[]
  isMobile?: boolean
}

const CTASubtextGroup = ({ subtexts, isMobile }: CTASubtextGroupProps) => (
  <div className={isMobile ? styles.mobile : styles.desktop}>
    <div className={styles.ctaSubtextGroup}>
      {subtexts.map((subtext, index) => (
        <>
          <CTASubtext key={index} {...subtext} />
          {index < subtexts.length - 1 && <div className={styles.divider} />}
        </>
      ))}
    </div>
  </div>
)

export default CTASubtextGroup
